import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import SingleLesson from './SingleLesson';
import { MentalLinkIdentifier, LessonLinkIdentifier } from '../../types';
import MentalApi from '../../lib/MentalApi';
import MentalNotFound from '../../components/MentalNotFound';

interface MatchParams {
    mentalId: string,
    mentalSlug: string,
    parentLessonId?: string,
    parentLessonSlug?: string,
    lessonId: string,
    lessonSlug: string,
}

interface LocationState {
    fromFavorites: boolean|undefined,
}

interface PageProps extends RouteComponentProps<MatchParams, any, LocationState> {
}

const SingleLessonWithData = ({ match, history, location }: PageProps) => {
    const mental: MentalLinkIdentifier = {
        mentalId: match.params.mentalId,
        mentalSlug: match.params.mentalSlug,
    };

    let parentLesson: LessonLinkIdentifier | undefined;

    if (match.params.parentLessonId && match.params.parentLessonSlug) {
        parentLesson = {
            mental,
            lessonId: match.params.parentLessonId,
            lessonSlug: match.params.parentLessonSlug,
        };
    }

    const lesson = MentalApi.getSingleLesson(
        mental,
        parentLesson,
        match.params.lessonId,
    );

    if (lesson === undefined) {
        return (
            <MentalNotFound
                what="Übung"
            />
        );
    }

    const mentalPageLayout = MentalApi.getMentalPageLayout(mental.mentalId);

    const isFromFavorites: boolean = Boolean(location.state && location.state.fromFavorites);

    return SingleLesson({
        mentalPageLayout,
        lesson,
        lessonId: match.params.lessonId,
        history,
        isFromFavorites,
    });
};

export default SingleLessonWithData;
